import { BaseAIAdapter, AIAdapterResponse } from './AIAdapter';
import { aiConfig } from '../config/ai';
import { AISystem } from '../config/ai';

export class OpenAIAdapter extends BaseAIAdapter {
  readonly system: AISystem;
  readonly name: string;
  protected apiKey: string;
  private model: string;

  constructor(system: 'openai' | 'copilot' = 'openai') {
    super();
    this.system = system;
    this.name = system === 'openai' ? 'ChatGPT' : 'Microsoft Copilot';
    this.apiKey = aiConfig.openai.apiKey;
    this.model = aiConfig.openai.model;
  }

  async query(prompt: string): Promise<AIAdapterResponse> {
    if (!this.isConfigured()) {
      throw new Error(`${this.name} adapter is not configured. Please provide an API key.`);
    }

    try {
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`,
        },
        body: JSON.stringify({
          model: this.model,
          messages: [
            {
              role: 'user',
              content: prompt,
            },
          ],
          temperature: 0.7,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || `HTTP ${response.status}`);
      }

      const data = await response.json();
      const text = data.choices[0]?.message?.content || '';

      return {
        rawText: text,
        modelVersion: data.model,
        timestamp: new Date(),
      };
    } catch (error: any) {
      this.handleError(error, this.name);
    }
  }

  getCacheTTL(): number {
    // Response non-determinism - moderate caching (12-24 hours)
    return 12 * 60 * 60 * 1000;
  }
}
